import { useCategories } from './useCategories'

const useDocumentCategory = () => {
  const { categories } = useCategories()

  const category = categories?.find((it) => it.categoryType === 'DOCUMENT')

  return { category }
}

export { useDocumentCategory }
